import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    loading: false,
    authenticated: false,
    user: {},
    reports: []
  };
};

export default new Vuex.Store({
  state: {
    loading: false,
    authenticated: false,
    user: {},
    reports: [],
    userReports: [],
    userInProgressReports: [],
    users: [],
    editUser: {},
    editUserErrors: [],
    editUserSuccess: false,
    createUserSuccess: false,
    createUserErrors: [],
    passwordResetErrors: [],
    passwordResetSuccess: false,
    userDeleteErrors: [],
    userDeleteSuccess: false
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    LOGIN_EVENT(state, payload) {
      state.authenticated = payload.authenticated;
      // state.user = payload.user;
    },
    LOGOUT_EVENT(state) {
      Object.assign(state, getDefaultState());
    },
    REPORTS_LOADED(state, payload) {
      state.reports = payload;
    },
    USER_REPORTS_LOADED(state, payload) {
      state.userReports = payload.Reports;
      state.userInProgressReports = payload.InProgressReports;
      state.user = payload.User;
    },
    ALL_USERS_LOADED(state, payload) {
      state.users = payload;
    },
    USER_EDIT_LOADED(state, payload) {
      state.editUser = payload;
    },
    USER_EDIT_ERRORS(state, payload) {
      state.editUserErrors = payload;
    },
    USER_EDIT_SUCCESS(state, payload) {
      state.editUserSuccess = payload;
    },
    USER_CREATE_SUCCESS(state, payload) {
      state.createUserSuccess = payload;
    },
    USER_CREATE_ERRORS(state, payload) {
      state.createUserErrors = payload;
    },
    PASSWORD_RESET_ERRORS(state, payload) {
      state.passwordResetErrors = payload;
    },
    PASSWORD_RESET_SUCCESS(state, payload) {
      state.passwordResetSuccess = payload;
    },
    USER_DELETE_ERRORS(state, payload) {
      state.userDeleteErrors = payload;
    },
    USER_DELETE_SUCCESS(state, payload) {
      state.userDeleteSuccess = payload;
    }
  },
  actions: {
    logout: ({ commit }) => {
      window.localStorage.removeItem("CWT_TOKEN");
      window.localStorage.removeItem("CWT_USER");
      commit("LOGOUT_EVENT");
      window.location = "/";
    },
    getReportTypes: async ({ commit }) => {
      commit("SET_LOADING", true);
      return new Promise(resolve => {
        Vue.prototype.$reports
          .getAllReports()
          .then(response => {
            commit("REPORTS_LOADED", response);
            commit("SET_LOADING", false);
            resolve(response);
          })
          .catch(() => {
            commit("REPORTS_LOADED", []);
            commit("SET_LOADING", false);
          });
      });
    },
    getUserReports: async ({ commit }) => {
      commit("SET_LOADING", true);
      await Vue.prototype.$reports
        .getReportsForUser()
        .then(response => {
          commit("USER_REPORTS_LOADED", response.data);
          commit("SET_LOADING", false);
        })
        .catch(() => {
          commit("USER_REPORTS_LOADED", []);
          commit("SET_LOADING", false);
        });
    },
    getAllUsers: async ({ commit }) => {
      commit("SET_LOADING", true);
      await Vue.prototype.$users
        .getAllUsers()
        .then(response => {
          commit("ALL_USERS_LOADED", response.data);
          commit("SET_LOADING", false);
        })
        .catch(() => {
          commit("ALL_USERS_LOADED", []);
          commit("SET_LOADING", false);
        });
    },
    getUserById: async ({ commit }, id) => {
      commit("SET_LOADING", true);
      await Vue.prototype.$users
        .getUserById(id)
        .then(response => {
          commit("USER_EDIT_LOADED", response.data);
          commit("SET_LOADING", false);
        })
        .catch(() => {
          commit("USER_EDIT_LOADED", {});
          commit("SET_LOADING", false);
        });
    },
    updateUser: async ({ commit }, user) => {
      commit("SET_LOADING", true);
      await Vue.prototype.$users
        .updateUser(user)
        .then(response => {
          if (response.status === 400) {
            commit("USER_EDIT_ERRORS", response.errors);
            commit("USER_EDIT_SUCCESS", false);
          } else {
            commit("USER_EDIT_LOADED", response.data);
            commit("USER_EDIT_SUCCESS", true);
          }

          commit("SET_LOADING", false);
        })
        .catch(error => {
          commit("USER_EDIT_ERRORS", error.response);
          commit("USER_EDIT_SUCCESS", false);
          commit("SET_LOADING", false);
        });
    },
    addUser: ({ commit }, user) => {
      commit("SET_LOADING", true);
      return new Promise(resolve => {
        Vue.prototype.$auth
          .createUser(user)
          .then(response => {
            if (response.status === 400) {
              commit("USER_CREATE_ERRORS", response.errors);
              commit("USER_CREATE_SUCCESS", false);
            } else {
              commit("USER_CREATE_ERRORS", []);
              commit("USER_CREATE_SUCCESS", true);
            }

            commit("SET_LOADING", false);

            resolve(response);
          })
          .catch(() => {
            commit("USER_CREATE_ERRORS", {});
            commit("SET_LOADING", false);
          });
      });
    },
    sendPasswordResetEmail: ({ commit }, email) => {
      commit("SET_LOADING", true);
      return new Promise(resolve => {
        Vue.prototype.$auth
          .sendPasswordResetEmail(email)
          .then(response => {
            if (response.status === 400) {
              commit("PASSWORD_RESET_ERRORS", response.errors);
              commit("PASSWORD_RESET_SUCCESS", false);
            } else {
              commit("PASSWORD_RESET_ERRORS", []);
              commit("PASSWORD_RESET_SUCCESS", true);
            }

            commit("SET_LOADING", false);

            resolve(response);
          })
          .catch(() => {
            commit("PASSWORD_RESET_ERRORS", []);
            commit("SET_LOADING", false);
          });
      });
    },
    resetPassword: ({ commit }, data) => {
      commit("SET_LOADING", true);
      return new Promise(resolve => {
        Vue.prototype.$auth
          .resetPassword(data)
          .then(response => {
            if (response.status === 400) {
              commit("PASSWORD_RESET_ERRORS", response.errors);
              commit("PASSWORD_RESET_SUCCESS", false);
            } else {
              commit("PASSWORD_RESET_ERRORS", []);
              commit("PASSWORD_RESET_SUCCESS", true);
            }

            commit("SET_LOADING", false);

            resolve(response);
          })
          .catch(() => {
            commit("PASSWORD_RESET_ERRORS", []);
            commit("SET_LOADING", false);
          });
      });
    },
    getUser: async ({ commit }) => {
      commit("SET_LOADING", true);
      await Vue.prototype.$users
        .getUser()
        .then(response => {
          commit("USER_EDIT_LOADED", response.data);
          commit("SET_LOADING", false);
        })
        .catch(() => {
          commit("USER_EDIT_LOADED", {});
          commit("SET_LOADING", false);
        });
    },
    editUser: async ({ commit }, user) => {
      commit("SET_LOADING", true);
      await Vue.prototype.$users
        .editUser(user)
        .then(response => {
          if (response.status === 400) {
            commit("USER_EDIT_ERRORS", response.errors);
            commit("USER_EDIT_SUCCESS", false);
          } else {
            commit("USER_EDIT_LOADED", response.data);
            commit("USER_EDIT_SUCCESS", true);
          }

          commit("SET_LOADING", false);
        })
        .catch(error => {
          commit("USER_EDIT_ERRORS", error.response);
          commit("USER_EDIT_SUCCESS", false);
          commit("SET_LOADING", false);
        });
    },
    deleteUser: async ({ commit, dispatch }, userId) => {
      commit("SET_LOADING", true);
      await Vue.prototype.$users
        .deleteUser(userId)
        .then(response => {
          if (response.status === 400) {
            commit("USER_DELETE_ERRORS", response.errors);
            commit("USER_DELETE_SUCCESS", false);
          } else {
            commit("USER_DELETE_SUCCESS", true);
            dispatch("getAllUsers");
          }

          commit("SET_LOADING", false);
        })
        .catch(error => {
          commit("USER_DELETE_ERRORS", error.response);
          commit("USER_DELETE_SUCCESS", false);
          commit("SET_LOADING", false);
        });
    }
  },
  getters: {
    reports: state => {
      return state.reports;
    },
    userReports: state => {
      return state.userReports;
    },
    userReportsInProgress: state => {
      return state.userInProgressReports;
    },
    user: state => {
      return state.user;
    },
    users: state => {
      return state.users;
    },
    editUser: state => {
      return state.editUser;
    },
    editUserErrors: state => {
      return state.editUserErrors;
    },
    editUserSuccess: state => {
      return state.editUserSuccess;
    },
    createUserSuccess: state => {
      return state.createUserSuccess;
    },
    createUserErrors: state => {
      return state.createUserErrors;
    },
    passwordResetErrors: state => {
      return state.passwordResetErrors;
    },
    passwordResetSuccess: state => {
      return state.passwordResetSuccess;
    },
    userDeleteErrors: state => {
      return state.userDeleteErrors;
    },
    userDeleteSuccess: state => {
      return state.userDeleteSuccess;
    }
  }
});
